<template>
  <el-popover
    @show="handleDeductDetail(itemData)"
    v-if="itemData.deductAmount !== 0"
    title="抵扣借支"
    trigger="hover"
    width="500"
  >
    <div slot="reference" class="primary cur">{{itemData.deductAmount}}</div>
    <el-table
      v-loading="tableData.loading"
      ref="multipleTable"
      :data="tableData.data"
      tooltip-effect="dark"
    >
      <el-table-column
        v-for="(item, index, key) in tableData.title"
        :key="key"
        :prop="item.prop"
        :label="item.label"
        :min-width="item.minW"
        :width="item.w"
      />
    </el-table>
  </el-popover>
</template>

<script>
import {
  manageDeductDetail,
} from 'api/cost';
export default {
  props: {
    itemData: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'appDate',
            label: '借支时间',
            w: '150px',
          },
          {
            prop: 'amount',
            label: '借支金额',
          },
          {
            prop: 'unPayAmount',
            label: '未核销金额',
            w: '100px',
          },
          {
            prop: 'deductAmount',
            label: '抵扣金额',
          },
          {
            prop: 'loanSubjectName',
            label: '借支类型',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    async handleDeductDetail (item) {
      if (!item.FaddeductDetailList) {
        item.FaddeductDetailList = true;
        this.tableData.loading = true;
        const res = await manageDeductDetail({
          relBusiCode: item.busiCode,
          LId: item.payId,
        });
        this.tableData.loading = false;
        if (res && res.items) {
          this.tableData.data = res.items.map((item) => ({
            appDate: item.appDate, // 借支时间
            amount: item.amount / 100, // 借支金额
            unPayAmount: item.unPayAmount / 100, // 未核销金额
            deductAmount: item.deductAmount / 100, // 抵扣金额
            loanSubjectName: item.loanSubjectName, // 借支类型
          }));
        }
      }
    },
  },
};
</script>

<style>

</style>
